import { gql } from '@apollo/client';

export const GetMyFindGroupsQueryName = 'GetMyFindGroups';

export const GET_MY_FIND_GROUPS_QUERY = gql`
  query ${GetMyFindGroupsQueryName} {
    getMyFindGroups {
      id
      createdAt
      createdBy
      name
      description
      shared
      level
    }
  }
`;
